<!-- 合同审批-->
<template>
  <div class="wrapper">
    <div class="navCard">
      <a
        v-for="(item, index) in tabs"
        :key="index"
        :class="[activeTab == index ? 'active' : '']"
        @click="changeTab(index)"
        >{{ item.title }}<span v-if="activeTab == index"></span
      ></a>
    </div>
    <div class="mainCard">
      <div class="mainBox">
        <div class="card">
          <div class="cardTitle">
            <h3>基本信息</h3>
            <span>{{
              myDataObj.approStatus | itemFilter('approve_status', allSelect)
            }}</span>
          </div>
          <p>
            <label>审核类型</label>
            <span>{{ myDataObj.groupName }}</span>
          </p>
          <p>
            <label>发起人</label>
            <span>{{ myDataObj.promoterName }}</span>
          </p>
          <p>
            <label>发起时间</label>
            <span>{{ myDataObj.promoterTime }}</span>
          </p>
          <p>
            <label>审批时长</label>
            <span>{{ myDataObj.diff | timeFilter }}</span>
          </p>
        </div>
        <div class="card">
          <div class="cardTitle">
            <h3>协议基本信息</h3>
            <!-- <a>查看合同<img src="@/assets/img/titleRight.png" alt=""></a> -->
          </div>
          <div class="cardMain" v-if="myDataObj.bizFlag != 'YXJIEY'">
            <div class="box">
              <p>
                <label>租赁面积</label>
                <span>{{ contractDetail.rentArea }}㎡</span>
              </p>
              <p>
                <label>物业面积</label>
                <span>{{ contractDetail.propertyArea }}㎡</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>租赁保证金</label>
                <span>{{ contractDetail.rentBailAmount }}元</span>
              </p>
              <p>
                <label>物业保证金</label>
                <span>{{ contractDetail.propertyBailAmount }}元</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>租赁意向金</label>
                <span>{{ contractDetail.rentIntentBailAmount }}元</span>
              </p>
              <p>
                <label>物业意向金</label>
                <span>{{ contractDetail.propertyIntentBailAmount }}元</span>
              </p>
            </div>
            <p>
              <label>协议面价</label>
              <span>{{ contractDetail.rentPrice }}元</span>
            </p>
            <p>
              <label>条款类型</label>
              <i
                v-if="
                  contractDetail.intentType == 1 ||
                    contractDetail.intentType == 3
                "
                class="zu"
                >租</i
              >
              <i
                v-if="
                  contractDetail.intentType == 2 ||
                    contractDetail.intentType == 3
                "
                class="wu"
                >物</i
              >
            </p>
            <p>
              <label>跟进人</label>
              <span>{{ contractDetail.traceUserName }}</span>
            </p>
            <div class="dateCard">
              <div class="dateBox">
                <label>起始日期</label>
                <span>{{ contractDetail.startDate }}</span>
              </div>
              <div class="dateBox">
                <label>到期日期</label>
                <span>{{ contractDetail.endDate }}</span>
              </div>
              <div class="dateBox">
                <label>签订日期</label>
                <span>{{ contractDetail.signDate }}</span>
              </div>
            </div>
            <p>
              <label>租期</label>
              <span>{{ contractDetail.period }}</span>
            </p>
            <p>
              <label>协议类型</label>
              <span>{{
                contractDetail.collection
                  | itemFilter('intent_collection', allSelect)
              }}</span>
            </p>
            <p>
              <label>租客信息</label>
              <span>{{ contractDetail.merchantName }}</span>
            </p>
          </div>
          <div class="cardMain" v-else>
            <p>
              <label>协议编号</label>
              <span>{{
                intentionObj.bsIntentHeaderBean.intentCode
                  ? intentionObj.bsIntentHeaderBean.intentCode
                  : '-'
              }}</span>
            </p>
            <p>
              <label>解约企业</label>
              <span>{{ intentionObj.bsIntentHeaderBean.merchantName }}</span>
            </p>
            <div class="box">
              <p>
                <label>解约生效日</label>
                <span>{{
                  intentionObj.bsIntentHeaderBean.cancelEffectDate
                }}</span>
              </p>
              <p>
                <label>解约签订日</label>
                <span>{{
                  intentionObj.bsIntentHeaderBean.cancelSignDate
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag != 'YXJIEY'">
          <div class="cardTitle">
            <h3>房源信息</h3>
          </div>
          <div class="houseCard">
            <div class="houseTitle">
              <span class="buildName">楼宇</span>
              <span class="floorName">楼层</span>
              <span class="houseCode">房号</span>
              <span class="area">面积(㎡)</span>
            </div>
            <div class="houseBox">
              <p
                v-for="item in contractDetail.bsIntentSpaceList"
                :key="item.id"
              >
                <span class="buildName">{{ item.buildName }}</span>
                <span class="floorName">{{ item.floorName }}</span>
                <span class="houseCode">{{ item.spaceName }}</span>
                <span class="area">{{ item.maxArea }}㎡</span>
              </p>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'YXJIEY'">
          <div class="cardTitle">
            <h3>费用总计</h3>
          </div>
          <div class="totalCostCard">
            <div class="totalCostTitle">
              <span class="type">类型</span>
              <span class="should">应收/退</span>
              <span class="account">金额(元)</span>
            </div>
            <div class="totalCostBox">
              <p v-for="item in intentionObj.breakFeeGatherVoList">
                <span class="type">{{
                  item.feeCode == '2' ? '意向金结算' : '其它计费'
                }}</span>
                <span class="should">{{
                  item.retreat == '1' ? '收' : '退'
                }}</span>
                <span class="account">{{ item.money }}</span>
              </p>
            </div>
            <div class="sum" v-if="intentionObj.allFinBill">
              <h4>
                {{
                  intentionObj.allFinBill.billType == '1'
                    ? '总计应收：'
                    : '总计应退：'
                }}<span>{{ intentionObj.allFinBill.planAmount }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'YXJIEY'">
          <div class="cardTitle">
            <h3>解约原因</h3>
          </div>
          <p class="cancel">
            <span v-for="item in intentionObj.bsIntentHeaderBean.reasons">{{
              item
            }}</span>
          </p>
          <p class="cancel" v-if="intentionObj.bsIntentHeaderBean.remark">
            {{ intentionObj.bsIntentHeaderBean.remark }}
          </p>
        </div>

        <!--审批附件  gdx-->
        <div class="card" v-if="approveFileArr.length > 0">
          <div class="cardTitle">
            <h3>审批附件</h3>
          </div>
          <div class="appendixCard" v-if="sence == 1">
            <div
              v-for="item in approveFileArr"
              @click="showFilepage(item)"
              :key="item.id"
            >
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </div>
          </div>
          <div class="appendixCard" v-else>
            <a :href="item.path" v-for="item in approveFileArr" :key="item.id">
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </a>
          </div>
        </div>
        <approvalProgress :myDataObj="myDataObj"></approvalProgress>
      </div>
    </div>
    <footer v-if="edit">
      <a @click="showShadow = 2">不通过</a>
      <a @click="showShadow = 1">审批通过</a>
    </footer>
    <div v-if="showShadow" class="shadowCard">
      <div class="shadowBox">
        <h3>审批原因</h3>
        <textarea placeholder="请输入说明信息" v-model="markContent"></textarea>
        <div class="btnCard">
          <a @click="showShadow = false">取消</a>
          <a @click="doInstance(showShadow)">确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './approvalMixin' // 引入mixin文件
import BScroll from 'better-scroll'
import {
  loadOneInnstance,
  loadIntentInfoById,
  queryContractApproveAttachmentList,
  loadIntentCalDataByIntentPk
} from '@/utils/api'

export default {
  name: 'intentionApproval',
  mixins: [mixin],
  data() {
    return {
      contractDetail: {},
      intentionObj: {
        bsIntentHeaderBean: {
          reasons: ''
        },
        bsMerchantVo: {},
        keywordMapList: [],
        bsContractRentClauseList: [],
        bsContractPropertyClauseList: [],
        bsChargeDetailVo: {
          rentClauseDetailList: [],
          propertyClauseDetailList: []
        },
        supplyClause: null
      }
    }
  },
  created() {
    this.getApproveFileFn()
  },
  methods: {
    loadOneInnstance() {
      let timestamp = new Date().getTime()
      loadOneInnstance({
        userId: this.userInfo.userInfo.id,
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.$route.query.id
      }).then(res => {
        this.myDataObj = res.data
        if (this.myDataObj.bizFlag == 'YXJIEY') {
          //走解约
          loadIntentInfoById({
            id: this.myDataObj.bsid,
            version: JSON.parse(this.myDataObj.businessData).version
          }).then(res2 => {
            this.intentionObj = JSON.parse(JSON.stringify(res2.data))
            let reasons = this.intentionObj.bsIntentHeaderBean.reasons.split(
              ','
            )
            reasons = reasons.map(value => {
              switch (value) {
                case '1':
                  return '租客意愿改变'
                  break
                case '2':
                  return '租客资质不全'
                  break
                case '3':
                  return '我方主动调整'
                  break
                case '4':
                  return '其它原因'
                  break
                default:
              }
            })
            this.intentionObj.bsIntentHeaderBean.reasons = reasons
            this.$nextTick(function() {
              let mainCard = document.querySelector('.mainCard')
              this.scroll = new BScroll(mainCard, {
                scrollY: true,
                click: true
              })
            })
          })
        } else {
          //走新增等
          loadIntentCalDataByIntentPk({
            intentPk: this.myDataObj.bsid
          }).then(res6 => {
            this.contractDetail = res6.data
            this.$nextTick(function() {
              let mainCard = document.querySelector('.mainCard')
              this.scroll = new BScroll(mainCard, {
                scrollY: true,
                click: true
              })
            })
          })
        }
        for (let i = 0; i < res.data.taskList.length; i++)
          if (
            res.data.taskList[i].nodeType != 1 &&
            res.data.taskList[i].nodeType != 4 &&
            res.data.currentNodeId == res.data.taskList[i].nodeId &&
            res.data.subRound == res.data.taskList[i].subRound &&
            !res.data.taskList[i].itemPassMethod &&
            res.data.taskList[i].receiverId == this.userInfo.userInfo.id &&
            (res.data.approStatus == 1000 || res.data.approStatus == 3000)
          ) {
            this.edit = true
            return
          }
      })
    },
    /*获取审批附件函数*/
    getApproveFileFn() {
      queryContractApproveAttachmentList({
        target: this.$route.query.id,
        moduleCode: 'BPM'
      }).then(res => {
        this.approveFileArr = res.data

        this.$nextTick(function() {
          let mainCard = document.querySelector('.mainCard')
          this.scroll = new BScroll(mainCard, {
            scrollY: true,
            click: true
          })
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;

  header {
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 48px;

    img {
      width: 44px;
      height: 44px;
      position: absolute;
      left: 28px;
    }
  }

  .navCard {
    height: 88px;
    display: flex;

    a {
      flex: 1;
      height: 88px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 88px;
      text-align: center;
      position: relative;
    }

    .active {
      color: rgba(61, 96, 223, 1);
    }

    span {
      display: block;
      width: 40px;
      height: 6px;
      background: linear-gradient(
        270deg,
        rgba(79, 132, 255, 1) 0%,
        rgba(76, 90, 255, 1) 100%
      );
      border-radius: 4px 4px 0 0;
      position: absolute;
      bottom: 0;
      left: 106px;
    }
  }

  .mainCard {
    flex: 1;
    overflow: hidden;

    .mainBox {
      background: rgba(247, 248, 249, 1);
      padding: 20px;

      .card {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.02);
        border-radius: 16px;
        padding-bottom: 30px;
        margin-bottom: 20px;

        .cardTitle {
          height: 88px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.09);

          h3 {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.8);
            line-height: 40px;
          }

          span {
            width: 104px;
            height: 44px;
            background: rgba(255, 246, 238, 1);
            border-radius: 22px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 173, 93, 1);
            line-height: 44px;
            text-align: center;
          }

          a {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 40px;
            display: flex;

            img {
              width: 40px;
              height: 40px;
            }
          }
        }

        p {
          display: flex;
          margin-top: 30px;
          padding: 0 30px;

          label {
            width: 120px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 34px;
            margin-right: 30px;
          }

          span {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
            line-height: 34px;
          }

          i {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 40px;
            text-align: center;
            margin-right: 10px;
          }

          .zu {
            background: rgba(0, 0, 0, 0.02);
            border: 2px solid rgba(0, 0, 0, 0.15);
            color: rgba(0, 0, 0, 0.6);
          }

          .wu {
            background: rgba(61, 96, 223, 0.1);
            border: 2px solid rgba(61, 96, 223, 0.2);
            color: rgba(61, 96, 223, 1);
          }

          .bu {
            background: rgba(22, 188, 132, 0.1);
            border: 2px solid rgba(22, 188, 132, 0.2);
            color: rgba(22, 188, 132, 1);
          }
        }

        .box {
          display: flex;

          p {
            flex: 1;
          }
        }

        .dateCard {
          width: 670px;
          height: 120px;
          background: rgba(247, 248, 249, 1);
          border-radius: 16px;
          margin: 30px 20px 0;
          display: flex;

          .dateBox {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            label {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.4);
              line-height: 34px;
              margin-bottom: 6px;
            }

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
              margin-top: 6px;
            }
          }
        }

        .houseCard {
          padding: 20px;

          .houseTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .buildName {
            width: 256px;
          }

          .floorName {
            width: 122px;
          }

          .houseCode {
            width: 158px;
          }

          .area {
            width: 114px;
          }
        }

        .totalCostCard {
          padding: 20px 20px 0;

          .totalCostTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .totalCostBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .sum {
            height: 88px;
            box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.09);
            display: flex;
            align-items: center;
            justify-content: flex-end;

            h4 {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;

              span {
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.8);
                line-height: 40px;
              }
            }
          }

          .type {
            flex: 1;
          }

          .should {
            width: 240px;
          }

          .account {
            width: 140px;
          }
        }

        .changeCard {
          .changeTitle {
            display: flex;
            margin-top: 30px;
            margin-left: 30px;

            a {
              width: 114px;
              height: 44px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 44px;
              text-align: center;
              background: rgba(0, 0, 0, 0.04);
            }

            .activeChangeTitle {
              background: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1) 0%,
                rgba(76, 90, 255, 1) 100%
              );
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        .cancel {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }

        .appendixCard {
          display: flex;
          flex-direction: column;
          align-items: center;

          a,
          div {
            width: 670px;
            height: 100px;
            background: rgba(247, 248, 249, 1);
            border-radius: 16px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(61, 96, 223, 1);
            line-height: 40px;
            box-sizing: border-box;

            .approveFileBox {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: block;
            }

            span {
              display: flex;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
              }

              &:first-child {
                flex: 1;
              }

              &:last-child {
                width: 160px;
                text-align: right;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }

  footer {
    height: 112px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;

    a {
      &:first-child {
        width: 296px;
        height: 72px;
        border-radius: 40px;
        border: 1px solid rgba(61, 96, 223, 1);
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(61, 96, 223, 1);
        line-height: 72px;
        text-align: center;
      }

      &:last-child {
        width: 296px;
        height: 72px;
        background: linear-gradient(
          270deg,
          rgba(79, 132, 255, 1) 0%,
          rgba(76, 90, 255, 1) 100%
        );
        border-radius: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 72px;
        text-align: center;
      }
    }
  }

  .shadowCard {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .shadowBox {
      width: 540px;
      height: 360px;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;

      h3 {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 44px;
        margin: 40px 0;
        text-align: center;
      }

      textarea {
        width: 474px;
        height: 100px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        margin-left: 32px;
        padding: 10px;
        box-sizing: border-box;
      }

      .btnCard {
        width: 540px;
        height: 96px;
        background: rgba(245, 245, 245, 1);
        border-radius: 0px 0px 16px 16px;
        margin-top: 40px;
        display: flex;

        a {
          flex: 1;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 96px;
          text-align: center;
        }
      }
    }
  }
}
</style>
